module.exports = __webpack_public_path__ + "static/media/cards.ded56b45.jpg";